import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PLATFORM_ID, Inject } from '@angular/core';
import * as moment from 'jalali-moment';


@Injectable({
  providedIn: 'root'
})
export class GeneralService implements OnInit, OnDestroy {
  readonly basePath = environment.SHARE_PATH;
  postID = new BehaviorSubject<string>('');
  href = new BehaviorSubject<string>('');
  categoryParent = new BehaviorSubject<string>('tabList');
  subscription: Subscription[] = [];
  entityName: string | undefined | null = '';
  constructor(
    private snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platform: Object
  ) { }
  ngOnInit() { }
  RegEx(name: string | null | undefined) {
    let n = name;
    n = n?.replaceAll(/[^\u0600-\u06FF\sa-zA-Z0-9-_.]/g, '');
    n = n?.replace(/[' ']/g, '-');
    n = n?.replace(/['‌']/g, '-');
    return n;
  }
  RegProfileUrl(name: string | null | undefined) {
    let n = name;
    n = n?.replace(/[' ']/g, '-');
    n = n?.replace(/['‌']/g, '-');
    return n;
  }
  HtmlToText(name: string) {
    let n = name;
    n = n?.replace(/<[^>]*>/g, '');
    n = n?.replace(/['&quot;']/g, '');
    n = n?.replace(/['&apos;']/g, '');
    n = n?.replace(/['&zwnj;']/g, '');
    n = this.WordCounter(n, 30)
    return n;
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2.5 * 1000
    })
  }
  CopyPost(
    entity: string | null | undefined,
    username: string | null | undefined,
    postSlug: string | null | undefined) {
    return `${this.basePath}${entity}/${username}/negare/${postSlug}`
  }
  CopyMagezine(
    magUser: string | null | undefined) {
    return `${this.basePath}katibe/${magUser}`
  }
  CopyOrgan(
    organUser: string | null | undefined) {
    return `${this.basePath}organ/${organUser}`
  }
  CopyProfile(
    nameUser: string | null | undefined) {
    return `${this.basePath}hamafarin/${nameUser}`
  }
  share(url: string) {
    if (navigator.share) {
      navigator.share({
        title: 'اشتراک گذاشتن',
        url: `${url}`
      })
        .catch(console.error)
    }
  }
  WordCounter(value: string, limit: number, trail: String = '…'): string {
    let result = value || '';
    if (value) {
      const words = value.split(/\s+/);
      if (words.length > Math.abs(limit)) {
        if (limit < 0) {
          limit *= -1;
          result = trail + words.slice(words.length - limit, words.length).join(' ');
        } else {
          result = words.slice(0, limit).join(' ') + trail;
        }
      }
    }
    return result;
  }
  convDegitToEnglish(str: string): any {
    // console.log(str)
    return str?.replaceAll('۰', '0').replaceAll('۱', '1').replaceAll('۲', '2').replaceAll('۳', '3').replaceAll('۴', '4')
      .replaceAll('۵', '5').replaceAll('۶', '6').replaceAll('۷', '7').replaceAll('۸', '8').replaceAll('۹', '9')

  }
  ConvertToPr(str: any) {
    return str?.replaceAll(/0/g, '۰')?.replaceAll(/1/g, '۱')?.replaceAll(/2/g, '۲')?.replaceAll(/3/g, '۳')?.replaceAll(/4/g, '۴')
      ?.replaceAll(/5/g, '۵')?.replaceAll(/6/g, '۶')?.replaceAll(/7/g, '۷')?.replaceAll(/8/g, '۸')?.replaceAll(/9/g, '۹')
      ?.replaceAll(/۰/g, '۰')?.replaceAll(/۱/g, '۱')?.replaceAll(/۲/g, '۲')?.replaceAll(/۳/g, '۳')?.replaceAll(/۴/g, '۴')
      .replaceAll(/۵/g, '۵')?.replaceAll(/۶/g, '۶')?.replaceAll(/۷/g, '۷')?.replaceAll(/۸/g, '۸')?.replaceAll(/۹/g, '۹');
  }
  hexToRgb(hex: string, alpha: number = 1) {
    if (hex) {
      let h = hex.replaceAll('"', '');
      let r = '0', g = '0', b = '0';
      if (h.length == 4) {
        r = "0x" + h[1] + h[1];
        g = "0x" + h[2] + h[2];
        b = "0x" + h[3] + h[3];

      } else if (h.length == 7 || h.length == 9) {
        r = "0x" + h[1] + h[2];
        g = "0x" + h[3] + h[4];
        b = "0x" + h[5] + h[6];
      }
      return "rgb(" + +r + "," + +g + "," + +b + "," + alpha + ")";
    }
    return "rgb(120,30,50" + alpha + ")";
  }

  setEntityFullName(entityName: string) {
    this.entityName = entityName
  }
  getEntityFullName() {
    return this.entityName
  }

  changeImageName(logo: any, type: any, title: any) {
    let name = '';
    if (logo) {
      let array = logo.name?.split('.');
      let format = array[array.length - 1];
      name = `roshdima-${this.RegEx(title)}${type}.${format}`
    }
    return name
  }
  ngOnDestroy() {
    this.subscription.forEach(sub => sub.unsubscribe())
  }
  getCurrentJalaliYear() {
    const m = moment();
    m.locale('fa');
    return +m.format('YYYY'); // it would be in jalali system
  }
}